import axiosInstance from "api/axiosInstance"
import SAlert from "components/Alert"
import { fundCodeAction } from "./fund-code-slice"
import { batch } from "react-redux"
import exportAxiosInstance from "api/exportAxiosInstance"
import FileSaver from "file-saver"

export const getFundCodes =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  dispatch => {
    dispatch(fundCodeAction.setLoading(true))
    url = url || "/v1/fund-codes"
    axiosInstance
      .get(url, {
        params: {
          pageNumber,
          according,
          search,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(fundCodeAction.setError(null))
            dispatch(fundCodeAction.setData(response.data))
            dispatch(fundCodeAction.setLoading(false))
          })
        }
      })
      .catch(() => {
        dispatch(fundCodeAction.setLoading(false))
      })
  }

export const deleteFundCode = id => dispatch => {
  dispatch(fundCodeAction.setLoading(true))
  axiosInstance
    .delete(`/v1/fund-codes/${id}`)
    .then(() => {
      dispatch(getFundCodes())
      SAlert({
        title: "Success",
        text: "Fund Code successfully deleted",
      })
      batch(() => {
        dispatch(fundCodeAction.setError(null))
        dispatch(fundCodeAction.setLoading(false))
      })
    })
    .catch(() => {
      dispatch(fundCodeAction.setLoading(false))
    })
}

export const storeFundCode = (data, navigate) => dispatch => {
  dispatch(fundCodeAction.setLoading(true))
  axiosInstance
    .post("/v1/fund-codes", data)
    .then(() => {
      navigate("/fund-codes")
      SAlert({
        title: "Success",
        text: "Fund Code successfully inserted",
      })
      batch(() => {
        dispatch(fundCodeAction.setError(null))
        dispatch(fundCodeAction.setLoading(false))
      })
    })
    .catch(err => {
      dispatch(fundCodeAction.setLoading(false))
      dispatch(fundCodeAction.setError(err?.response?.data?.errors))
    })
}

export const updateFundCode = (id, data, navigate) => dispatch => {
  dispatch(fundCodeAction.setLoading(true))
  axiosInstance
    .put(`/v1/fund-codes/${id}`, data)
    .then(() => {
      navigate("/fund-codes")
      SAlert({
        title: "Success",
        text: "Fund Code successfully updated",
      })
      batch(() => {
        dispatch(fundCodeAction.setError(null))
        dispatch(fundCodeAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(fundCodeAction.setLoading(false))
      dispatch(fundCodeAction.setError(error?.response?.data?.errors))
    })
}

export const getByIdFundCode = id => dispatch => {
  dispatch(fundCodeAction.setLoading(true))
  axiosInstance
    .get(`/v1/fund-codes/${id}`)
    .then(response => {
      batch(() => {
        dispatch(fundCodeAction.setError(null))
        dispatch(fundCodeAction.setLoading(false))
        dispatch(fundCodeAction.setFundCode(response.data))
      })
    })
    .catch(() => {
      dispatch(fundCodeAction.setLoading(false))
    })
}

export const exportFundCodes = search => dispatch => {
  dispatch(
    fundCodeAction.setExportStatus({
      loading: true,
      error: null,
    })
  )
  exportAxiosInstance
    .get("/v1/fund-codes-export", {
      params: { search },
    })
    .then(response => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        })
        FileSaver.saveAs(
          dataBlob,
          `Fund-Codes-${Math.random().toString()}.xlsx`
        )
        dispatch(
          fundCodeAction.setExportStatus({
            loading: false,
            error: null,
          })
        )
      }
    })
    .catch(error => {
      dispatch(
        fundCodeAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      )
    })
}
